import type { EstimateItem, EstimateUnit, PricingMode } from './estimate.types';
import { multiplyMoney, roundMoney } from './money';

function formatNumber(value: number): string {
  const rounded = Math.round(value * 100) / 100;
  return Number.isInteger(rounded) ? rounded.toFixed(0) : String(rounded);
}

export function createEstimateItem(input: {
  id: string;
  label: string;
  category: string;
  quantity: number;
  unit: EstimateUnit;
  unitPrice: number;
  pricingMode: PricingMode;
  calculation?: string;
  order?: number;
}): EstimateItem {
  const unitPrice = roundMoney(input.unitPrice);
  const total = multiplyMoney(input.quantity, unitPrice);
  const calculation =
    input.calculation ??
    `${formatNumber(input.quantity)} ${input.unit} × ${formatNumber(input.unitPrice)} zł/${input.unit} = ${formatNumber(total)} zł`;

  return {
    id: input.id,
    label: input.label,
    category: input.category,
    quantity: input.quantity,
    unit: input.unit,
    unitPrice,
    total,
    calculation,
    pricingMode: input.pricingMode,
    order: input.order,
    unitRateNetto: unitPrice,
    totalNetto: total,
  };
}

export { formatNumber };
